import React from "react";
import "./index.css";
import { Card, Typography } from "antd";
import SpeedGaugeChart from "./components/SpeedGaugeChart";
import { useGetRenewalAcceptedData } from "../hooks/useAccptedRenewalData";
import LoaderTsx from "../../../Loader.tsx";
import { currencyFormat } from "../../../../../utils/media";
const { Title, Text } = Typography;

const AcceptedRenewals: React.FC = React.memo(() => {


  const { isLoading, renewalAcceptedData }: any = useGetRenewalAcceptedData();
  const { totalRenewalSentCount, totalRenewalSentTotalAmount, renewalAcceptedPercentage, renewalAcceptedCount } =
    renewalAcceptedData;

    
  return (
    <Card
      style={{
        backgroundColor: "#F8F8F8",
        borderRadius: 8,
        border: "1px solid #E9E9E9",
        boxShadow: "none",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Title
          level={5}
          style={{
            margin: 0,
            color: "#1F5782",
            textTransform: "uppercase",
            fontWeight: 400,
          }}
        >
          <span style={{ fontWeight: 700 }}>ACCEPTED</span> <span style={{ fontWeight: 400 }}>RENEWALS</span>
        </Title>
      </div>

      {isLoading ? (
        <LoaderTsx height={"30vh"} />
      ) : (
        <>
          <SpeedGaugeChart renewalAcceptedPercentage={renewalAcceptedPercentage} />

          <Card
            style={{
              borderRadius: 12,
              textAlign: "center",
              border: "1px solid #E9E9E9",
              backgroundColor: "#FFFFFF",
              zIndex: 3,
              marginTop: "-78px",
            }}
            className="custom-card-gauge"
          >
            <Title level={1} style={{ fontSize: 30, color: "#1F4D63", marginBottom: 8 }}>
              {renewalAcceptedCount ? renewalAcceptedCount : 0}
            </Title>

            <Text style={{ color: "#666", fontSize: 12, fontWeight: 500 }}>
              Value: AED {currencyFormat(totalRenewalSentTotalAmount)}
            </Text>
          </Card>
          <Text
            style={{
              color: "#666",
              fontSize: 14,
              display: "block",
              marginTop: 2,
              textAlign: "center",
            }}
          >
            Payment Vs. Contract Signed
          </Text>
        </>
      )}
    </Card>
  );
});

export default AcceptedRenewals;
